import AddCompanyModal from './view/AddCompanyModal';
export default AddCompanyModal;

